import '@/common';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import { CardSliderWidget } from '@/widgets/CardSliderWidget';
import { feedbackWidget} from '@/common/widgets';
import { ModalData } from '@/widgets/FeedbackWidget/types';
import {JSONParser} from "@/utils/JSONParser";
import { createSliderWidget } from '@/widgets/SliderWidget';
import { createQuickPickWidget } from '@/widgets/QuickPickWidget';
import {createOpenFeedbackWidget} from "@/widgets/OpenFeedbackWidget";
import { createMapWidget } from '@/widgets/MapWidget';
import { createBestoffersWidget } from '@/widgets/BestoffersWidget';
import { createDecorationSliderWidget } from '@/widgets/DecorationSliderWidget';

gsap.registerPlugin(ScrollTrigger);
const parser = new JSONParser('project');

createBestoffersWidget(document.querySelector('#bestoffers-widget')!);

createDecorationSliderWidget(document.querySelector('#decoration-slider-widget')!);

[...document.querySelectorAll('.open-feedback-widget')].forEach((el) => {
    createOpenFeedbackWidget(el);
});

createQuickPickWidget(document.querySelector('#quick-pick-widget')!);

const sliderEl = document.querySelector('#slider-widget')
if(sliderEl) {
    createSliderWidget(sliderEl);
}
[...document.querySelectorAll('.slider-widget')].forEach((el) => {
    createSliderWidget(el);
});

[...document.querySelectorAll('.js-feedback-widget')].forEach((el) => {
    el.addEventListener('click', () => {
        const parser = new JSONParser('js-feedback-widget-parser');
        const action = el.getAttribute('data-action');
        const rawModalData = parser.parse<ModalData>(el.getAttribute('data-modal'));

        switch (action) {
            default:

                const trailer = Object.assign({}, rawModalData.trailer, {});

                const modalData = Object.assign({}, rawModalData, {
                    trailer,
                });

                feedbackWidget.show(modalData);
                break;
        }
    });
});

[...document.querySelectorAll('.flip-box-inner')].forEach((el) => {
    el.addEventListener('click', () => {
        el.classList.toggle('active');
    });
});

const mapWidget = document.getElementById('map-widget');
if(mapWidget) {
    const mapIgnition = ScrollTrigger.create({
        trigger: '#map-widget',
        onEnter(scrollTrigger) {
            createMapWidget(scrollTrigger.trigger!);
        },
    });
}
//window.addEventListener('load', () => {
    [...document.querySelectorAll('.video-block')].forEach((el) => {
        /*const videoEl = el.querySelector('video');
        if(videoEl) {
            el.addEventListener('click', function () {
                if (videoEl.paused) {
                    videoEl.play();
                } else {
                    videoEl.pause();
                }
            }, false);
        }*/

        const vkVideoApi = el.querySelector<HTMLElement>('.vk_video_api');

        //const vkVideoPoster = el.querySelector<HTMLElement>('.vk_video_poster')
        if (!vkVideoApi) {
            return;
        }

        el.addEventListener('click', function (e) {
            e.preventDefault();
            //const src = vkVideoApi.getAttribute('src');
            el.classList.toggle('active');
            const dataSrc = vkVideoApi.getAttribute('data-src');
            if (dataSrc) {
                //const srcNew = src.replace('autoplay=0', 'autoplay=1');
                vkVideoApi.setAttribute('src', dataSrc);
                vkVideoApi.removeAttribute('data-src');
            }
        });
    });
//});

window.addEventListener('load', () => {
    [...document.querySelectorAll<HTMLElement>('.card-slider')].forEach((el) => {
        const options = el.getAttribute('data-swiper-options');
        new CardSliderWidget(el, options ? parser.parse(options) : undefined);
    });
});
